export function standardDeliveryDaysCount(shippingCountry) {
  return shippingCountry === "FR" ? 3 : 4;
}
